import { setDate } from 'date-fns'
export default {
  // 当某月的天数
  getDaysInOneMonth(date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const d = new Date(year, month, 0)
    return d.getDate()
  },
  // 获取当前日期月份的日期区间，即当月第一天~当月最后一天的日期
  getDateRange(date) {
    // date为new Date() 类型出来的
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const totalDays = this.getDaysInOneMonth(date)
    const startTime = `${year}-${month}-1`
    const endTime = `${year}-${month}-${totalDays}`
    return { startTime, endTime }
  },
  // 向前空几个
  getMonthweek(date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const dateFirstOne = new Date(year + '/' + month + '/1')
    return this.sundayStart
      ? dateFirstOne.getDay() === 0
        ? 7
        : dateFirstOne.getDay()
      : dateFirstOne.getDay() === 0
      ? 6
      : dateFirstOne.getDay() - 1
  },
  // 获取当前日期上个月或者下个月
  getOtherMonth(date, str = 'nextMonth') {
    const timeArray = this.dateFormat(date).split('/')
    const year = timeArray[0]
    const month = timeArray[1]
    const day = timeArray[2]
    let year2 = year
    let month2
    if (str === 'nextMonth') {
      month2 = parseInt(month) + 1
      if (month2 === 13) {
        year2 = parseInt(year2) + 1
        month2 = 1
      }
    } else {
      month2 = parseInt(month) - 1
      if (month2 === 0) {
        year2 = parseInt(year2) - 1
        month2 = 12
      }
    }
    let day2 = day
    const days2 = new Date(year2, month2, 0).getDate()
    if (day2 > days2) {
      day2 = days2
    }
    if (month2 < 10) {
      month2 = '0' + month2
    }
    if (day2 < 10) {
      day2 = '0' + day2
    }
    const t2 = year2 + '/' + month2 + '/' + day2
    return new Date(t2)
  },
  // 上个月末尾的一些日期
  getLeftArr(date) {
    let arr = []
    const leftNum = this.getMonthweek(date)
    const num = this.getDaysInOneMonth(this.getOtherMonth(date, 'lastMonth')) - leftNum + 1
    const preDate = this.getOtherMonth(date, 'lastMonth')
    // 上个月多少开始
    for (let i = 0; i < leftNum; i++) {
      const nowTime = preDate.getFullYear() + '/' + (preDate.getMonth() + 1) + '/' + (num + i)
      arr.push({
        id: num + i,
        date: nowTime,
        isToday: false,
        otherMonth: `lastMonth`,
      })
    }
    return arr
  },
  // 下个月末尾的一些日期
  getRightArr(date) {
    let arr = []
    const nextDate = this.getOtherMonth(date, 'nextMonth')
    const leftLength = this.getDaysInOneMonth(date) + this.getMonthweek(date)
    const _length = 7 - (leftLength % 7)
    for (let i = 0; i < _length; i++) {
      const nowTime = nextDate.getFullYear() + '/' + (nextDate.getMonth() + 1) + '/' + (i + 1)
      arr.push({
        id: i + 1,
        date: nowTime,
        isToday: false,
        otherMonth: `nextMonth`,
      })
    }
    return arr
  },
  // 获取某月的列表不包括上月和下月
  getMonthListNoOther(date) {
    let arr = []
    const num = this.getDaysInOneMonth(date)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    let toDay = this.dateFormat(new Date())

    for (let i = 0; i < num; i++) {
      const nowTime = year + '/' + month + '/' + (i + 1)
      arr.push({
        id: i + 1,
        date: nowTime,
        isToday: toDay === nowTime,
        otherMonth: `nowMonth`,
      })
    }
    return arr
  },
  // 获取某月的列表 用于渲染
  getMonthList(date) {
    return [...this.getLeftArr(date), ...this.getMonthListNoOther(date), ...this.getRightArr(date)]
  },
  // 获取某周的列表 用于渲染
  getWeekList(date) {
    let arr = []
    for (let i = 0; i < 7; i++) {
      arr.push({
        date: this.dateFormat(this.setSomeDate(date, i)),
        duty: [
          { section: 1, list: [] },
          { section: 2, list: [] },
          { section: 3, list: [] },
          { section: 4, list: [] },
        ],
        isToday: this.dateFormat(this.setSomeDate(date, i)) === this.dateFormat(new Date()),
      })
    }
    return arr
  },
  // 设置某一天 即当前周的第一天 【周日】
  setSomeDate(date, i) {
    return setDate(date, date.getDate() + i)
  },
  // 时间戳转化为日期
  timestamp2date(nS, type) {
    return this.dateFormat(new Date(nS), type)
  },
  // 年月日格式化
  dateFormat(date, type = '/') {
    date = typeof date === 'string' ? new Date(date.replace(/\-/g, type)) : date
    return date.getFullYear() + type + (date.getMonth() + 1) + type + date.getDate()
  },
  sundayStart: true,
}
